import FilterSectionSwitcher from './FilterSectionSwitcher';

export default FilterSectionSwitcher;
